import { StyledProps } from '@front10';
import React from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import { TextProps } from '../../../elements/Text/Text';
import Title from './Title';

interface Props {
  showTitle?: boolean;
  showLocationDescriptionText?: boolean;
  titleStyles?: React.ComponentPropsWithoutRef<typeof Title>;
  locationDescriptionTextStyles?: TextProps;
  locationDescriptionText?: string;
}

function LocationDescriptionText({
  showTitle = true,
  showLocationDescriptionText = true,
  titleStyles,
  locationDescriptionTextStyles,
  locationDescriptionText = '',
  ...props
}: StyledProps<Props>) {
  return (
    <Box display="flex" flexDirection="column" {...props}>
      {showTitle && <Title {...titleStyles} />}
      {showLocationDescriptionText && (
        <Text {...locationDescriptionTextStyles}>{locationDescriptionText}</Text>
      )}
    </Box>
  );
}

LocationDescriptionText.componentName = 'LocationDescriptionText';

export default LocationDescriptionText;
